import React from 'react';
import { FormattedMessage } from 'react-intl';

const Filter = props => {
    const {
        filterList,
        filterInputsMaxLength,
        labelNames,
        formName,
        handleChange,
        resetHandler,
        applyHandler
    } = props;

    const filterInputs = Object.keys(filterList).map((filter, index) => {
        return (
            <div key={index} className="filter__form__input-wrapper grid-col-3">
                <label 
                    className=""
                    htmlFor={`input_${filter}`}>
                    {<FormattedMessage id={labelNames[filter]}/>}
                </label>
                <input
                    className="usa-input gi-input gi-input__text-align-left"
                    id={`input_${filter}`}
                    name={filter}
                    value={ filterList[filter] }
                    onChange={handleChange}
                    maxLength={filterInputsMaxLength[filter]}
                />
                
            </div>);
    });

    return (
        <form name={formName} className="filter__form" onSubmit={(e) => e.preventDefault()}>
            <div className="filter__form-filters">
                {filterInputs}
            </div>
            <div className='filter__form-controls' >
                <button
                    type="button"
                    className='usa-button gi-button gi-button__outline--blue'
                    onClick={resetHandler}
                >
                    <FormattedMessage id="delegation_filter_reset"/>
                </button>
                <button
                    type="button"
                    className='usa-button gi-button gi-button__primary'
                    onClick={applyHandler}
                >
                    <FormattedMessage id="delegation_filter_apply"/>
                </button>
            </div>
        </form>
    );
};

export default Filter;